module.exports = __webpack_public_path__ + "img/setting-img.35ed212c.png";